<div class="register-container">
    <div class="register-card">
        @if(!showSuccess){
        <div class="register-header">
            <h1>Créez votre compte</h1>
            <h3>Créez votre espace client et profitez d’un service de sécurité professionnel.</h3>
        </div>

        <form class="register-form" *ngIf="registerForm" [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>
            <!-- Step 1: Personal Information -->
            <div class="form-step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
                <div class="form-section">
                    <div class="form-row">
                        <div class="form-group name-group">
                            <input type="text" id="firstName" formControlName="firstName" [class.is-invalid]="firstName?.invalid && firstName?.touched" placeholder="Entrez votre prénom"> @if(firstName?.invalid && firstName?.touched) {
                            <div class="form_error">
                                <span *ngIf="firstName?.errors?.['required']">Le prénom est obligatoire</span>
                                <span *ngIf="firstName?.errors?.['maxlength']">Le prénom ne doit pas dépasser 100 caractères</span>
                            </div>
                            }
                        </div>

                        <div class="form-group name-group">
                            <input type="text" id="lastName" formControlName="lastName" [class.is-invalid]="lastName?.invalid && lastName?.touched" placeholder="Entrez votre nom"> @if(lastName?.invalid && lastName?.touched) {
                            <div class="form_error">
                                <span *ngIf="lastName?.errors?.['required']">Le nom est obligatoire</span>
                                <span *ngIf="lastName?.errors?.['maxlength']">Le nom ne doit pas dépasser 100 caractères</span>
                            </div>
                            }
                        </div>
                    </div>

                    <div class="form-group email-group">
                        <input type="text" id="email" formControlName="email" [class.is-invalid]="email?.invalid && email?.touched" placeholder="Choisissez un email"> @if(email?.invalid && email?.touched) {
                        <div class="form_error">
                            <span *ngIf="email?.errors?.['required']">L'email est obligatoire</span>
                            <span *ngIf="email?.errors?.['email']">Format d'email invalide</span>
                        </div>
                        }
                    </div>

                    <div class="form-group phone-group">
                        <input type="tel" id="phoneNumber" formControlName="phoneNumber" [class.is-invalid]="phoneNumber?.invalid && phoneNumber?.touched" placeholder="Entrez votre numéro de téléphone"> @if(phoneNumber?.invalid && phoneNumber?.touched)
                        {
                        <div class="form_error">
                            <span *ngIf="phoneNumber?.errors?.['required']">Le téléphone est obligatoire</span>
                            <span *ngIf="phoneNumber?.errors?.['phone']">Format de téléphone invalide</span>
                        </div>
                        }
                    </div>

                    <!-- Address Section -->
                    <div class="form-row" [formGroup]="addressForm">
                        <div class="form-group streetn-group">
                            <input type="text" id="streetNumber" formControlName="streetNumber" [class.is-invalid]="streetNumber?.invalid && streetNumber?.touched" placeholder="Numéro de rue"> @if(streetNumber?.invalid && streetNumber?.touched) {
                            <div class="form_error">
                                <span *ngIf="streetNumber?.errors?.['maxlength']">Le numéro de rue ne doit pas dépasser 200 caractères</span>
                            </div>
                            }
                        </div>

                        <div class="form-group street-group">
                            <input type="text" id="street" formControlName="street" [class.is-invalid]="street?.invalid && street?.touched" placeholder="Nom de la rue"> @if(street?.invalid && street?.touched) {
                            <div class="form_error">
                                <span *ngIf="street?.errors?.['maxlength']">Le nom de la rue ne doit pas dépasser 200 caractères</span>
                            </div>
                            }
                        </div>
                    </div>

                    <div class="form-row" [formGroup]="addressForm">
                        <div class="form-group zip-group">
                            <input type="text" id="postalCode" formControlName="postalCode" [class.is-invalid]="postalCode?.invalid && postalCode?.touched" placeholder="Code postal"> @if(postalCode?.invalid && postalCode?.touched) {
                            <div class="form_error">
                                <span *ngIf="postalCode?.errors?.['pattern']">Format de code postal invalide</span>
                            </div>
                            }
                        </div>
                        <div class="form-group city-group">
                            <input type="text" id="city" formControlName="city" [class.is-invalid]="city?.invalid && city?.touched" placeholder="Ville"> @if(city?.invalid && city?.touched) {
                            <div class="form_error">
                                <span *ngIf="city?.errors?.['maxlength']">La ville ne doit pas dépasser 100 caractères</span>
                            </div>
                            }
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group company-group">
                            <input type="text" id="companyName" formControlName="companyName" [class.is-invalid]="companyName?.invalid && companyName?.touched" placeholder="Société"> @if(companyName?.invalid && companyName?.touched) {
                            <div class="form_error">
                                <span *ngIf="companyName?.errors?.['required']">Le nom de la société est obligatoire</span>
                            </div>
                            }
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group vatNumber-group">
                            <input type="text" id="vatNumber" formControlName="vatNumber" [class.is-invalid]="vatNumber?.invalid && vatNumber?.touched" placeholder="N° TVA"> @if(vatNumber?.invalid && vatNumber?.touched) {
                            <div class="form_error">
                                <span *ngIf="vatNumber?.errors?.['required']">Le numéro de TVA est obligatoire</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <!-- Step 1 Navigation -->
                <div class="step-navigation">
                    <button type="button" class="next-step-btn" (click)="goToNextStep()" [disabled]="!isStep1Valid()">
                        <span>Confirmer</span>
                        <img src="assets/images/icons/arrow-right.png" alt="Next" class="arrow-icon">
                    </button>
                </div>
            </div>

            <!-- Step 2: Password -->
            <div class="form-step" [class.active]="currentStep === 2">
                <!-- Password Section -->
                <div class="form-section">
                    <div class="form-row">
                        <div class="form-group">
                            <div class="input-group password-group">
                                <img src="assets/images/icons/lock-red.png" alt="lock-icon" class="input-icon">
                                <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password" [class.is-invalid]="password?.invalid && password?.touched" placeholder="Créez un mot de passe">
                                <button type="button" class="password-toggle" (click)="togglePassword('password')">
                                    <img src="assets/images/icons/eye.png" alt="eye-icon">
                                </button>
                            </div>
                            @if(password?.invalid && password?.touched) {
                            <div class="form_error">
                                <span *ngIf="password?.errors?.['required']">Le mot de passe est obligatoire</span>
                                <span *ngIf="password?.errors?.['password']">{{ password?.errors?.['password'] }}</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <div class="form-section">
                    <div class="form-row">
                        <div class="form-group confirmPassword-group">
                            <div class="input-group">
                                <img src="assets/images/icons/lock-red.png" alt="lock-icon" class="input-icon">
                                <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" formControlName="confirmPassword" [class.is-invalid]="confirmPassword?.invalid && confirmPassword?.touched" placeholder="Confirmez votre mot de passe">
                                <button type="button" class="password-toggle" (click)="togglePassword('confirmPassword')">
                                    <img src="assets/images/icons/eye.png" alt="eye-icon">
                                </button>
                            </div>
                            @if(confirmPassword?.invalid && confirmPassword?.touched) {
                            <div class="form_error">
                                <span *ngIf="confirmPassword?.errors?.['required']">La confirmation du mot de passe est obligatoire</span>
                                <span *ngIf="confirmPassword?.errors?.['mismatch']">Les mots de passe ne correspondent pas</span>
                            </div>
                            } @if(registerForm.errors?.['mismatch'] && (confirmPassword?.touched || password?.touched)) {
                            <div class="form_error">
                                <span>Les mots de passe ne correspondent pas</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <!-- Step 2 Navigation -->
                <div class="step-navigation">
                    <button type="button" class="back-step-btn" (click)="goToPreviousStep()">
                        <img src="assets/images/icons/arrow-left.png" alt="Back" class="arrow-icon">
                        <span>Informations personnelles</span>
                    </button>
                    <button type="submit" class="register-btn" [disabled]="isSubmitting || registerForm.invalid" [class.loading]="isSubmitting">
                        <span *ngIf="!isSubmitting">Confirmer</span>
                        <span *ngIf="isSubmitting">Création en cours...</span>
                    </button>
                </div>
            </div>
        </form>
        }

        <!-- Error Message -->
        @if(errorMessage){
        <div class="alert alert-error mt-3">
            <p class="form_error">{{ errorMessage }}</p>
        </div>
        }

        <!-- Success Message -->
        @if(showSuccess){
        <div class="alert-card-success">
            <h3 class="alert-title"><em class="fa fa-check"></em> Inscription Réussie!</h3>
            <p class="alert-text">{{ successMessage }}</p>
            <p class="alert-text verification-help">
                Vous n'avez pas reçu l'email?
            </p>
            <button type="button" class="link-button" (click)="resendVerification()" [disabled]="isLoading">
                <span *ngIf="!isLoading">Renvoyer le lien de vérification</span>
                <span *ngIf="isLoading">Envoi en cours...</span>
            </button>
        </div>
        }
    </div>

    <div class="image-col">
        <img src="assets/images/call-man.svg" alt="Security Call Center" class="login-image">
    </div>
</div>